import { useState, useEffect } from 'react';
import { InterimStates } from "../InterimStates";
import { Dropdown } from 'semantic-ui-react';
import { useQuery } from '@apollo/client';
import { GET_TAGS_FOR_GROUP, GET_GROUP_BY_GROUP_ID } from '../../queries/tags';

interface IProps {
    groupId: number;
    setValue: (code: string, groupId: number, tagId: number) => void;
    showErrors: boolean;
    initialValue?: string;
}

const GroupTagPicker = ({
    setValue,
    groupId,
    showErrors,
    initialValue,
}: IProps) => {
    const [tagId, setTagId] = useState<string | number>('');

    const { data, loading, error } = useQuery(GET_TAGS_FOR_GROUP, {
        variables: { groupId }
    });

    const { data: groupData } = useQuery(GET_GROUP_BY_GROUP_ID('name'), {
        variables: { groupId }
    });

    useEffect(() => {
        if (data && data.tagsForGroup && initialValue) {
            const matchingTag = data.tagsForGroup.find(
                (t: any) => t.code.toUpperCase() === initialValue.toUpperCase()
            );

            if (matchingTag) {
                setTagId(matchingTag.id);
                setValue(matchingTag.code, groupId, matchingTag.id);
            }
        }
    }, [data, initialValue, groupId]);

    if (loading || error) {
        return <InterimStates loading={loading} error={error} label='tags' />
    }

    const handleChange = (_: any, datum: any) => {
        const selectedId = datum.value;
        setTagId(selectedId);

        const selectedTag = data.tagsForGroup.find((p: any) => p.id === selectedId);
        if (selectedTag) {
            setValue(selectedTag.code, groupId, selectedId);
        }
    };

    const tagOptions = data.tagsForGroup.map((p: any) => ({
        key: p.id,
        text: p.name,
        value: p.id,
    }));

    // minimalist style - very small
    const styles: React.CSSProperties = {
        fontSize: '10px',
    };

    if (showErrors && tagId === '') {
        styles.backgroundColor = 'rgb(255, 246, 246)';
        styles.borderColor = 'rgb(224, 180, 180)';
    }

    return (
        <Dropdown
            style={styles}
            placeholder={groupData?.getGroup?.name || 'Group'}
            fluid
            value={tagId}
            onChange={handleChange}
            search
            selection
            options={tagOptions}
        />
    );
}

export { GroupTagPicker };
